import { translations } from "../../Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const userTable = translations[lang]?.userPage?.userTableCol

export const columns = [
  { label: userTable?.user_name || "USER NAME", dataKey: "name_english" },
  { label: userTable?.role || "ROLE", dataKey: "role" },
  { label: userTable?.email || "Email ADDRESS", dataKey: "email_address" },
  { label: userTable?.status || "STATUS", dataKey: "status" },
]
